// extracted by mini-css-extract-plugin
export default {"Loader":"loader_Loader__EnNMl","autoHeight":"loader_autoHeight__Y1LcF","autoWidth":"loader_autoWidth__nxgJa","Loader__fullH":"loader_Loader__fullH__97OMN"};